// Опрос, пока сервер доделывает работу (008): проверка подключения почты, регистрация отчётов
// о доставке, письмо в очереди. Опрос — не действие человека: фоновый запрос, сеанс не продлевает
// (FR-008б 001), скрытая вкладка сервер не опрашивает; запрос, который уже идёт, опрос
// не отменяет — как опрос «Оповещений» (AlertsPage).
import { useEffect } from 'react';
import { inBackground } from '../api/client.ts';

/** Опрос подключения почты, пока идёт проверка или регистрация отчётов. */
export const CHECK_POLL_MS = 2000;
/** Опрос писем, пока они в очереди или ждут отчёта о доставке. */
export const LETTERS_POLL_MS = 5000;

export function useBackgroundPoll(
  active: boolean,
  refetch: (options: { cancelRefetch: boolean }) => Promise<unknown>,
  intervalMs: number,
): void {
  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'hidden') return;
      void inBackground(() => refetch({ cancelRefetch: false }));
    }, intervalMs);
    return () => window.clearInterval(timer);
  }, [active, refetch, intervalMs]);
}
